<template>
  <div :class="fundo ? 'imagem-fundo' : 'container'" :style="fundo ? 'background-image: url(\'' + fundo + '\');' : ''">

    <cookie-law ref="cl" buttonText="Aceitar" @accept="aceitarTermos()" v-if="termo">
      <div slot="message">
        <span v-html="termo"></span>
      </div>
    </cookie-law>

    <div class="naesquerda loginmobile" v-if="pronto && fundo">
        <form @submit.prevent="logging" class="d-flex justify-content-center align-items-center h-100">
            <template v-if="user.token || user.id_marcacao">
                <az-loading msg="Aguarde..." />
            </template>

            <div class="card az-anime-surgir" style="padding: 0px;" :style="novaConta ? '' : 'max-width: 400px;'" v-else>
                <div class="card-header" :class="logo ? 'bg-white' : ''">
                <div class="d-flex justify-content-center">
                    <img
                    :src="logo"
                    alt="logo"
                    class="logo-responsive"
                    v-if="logo && logo != '?'"
                    />
                    <p class="lead text-center" v-else>{{ nome }}</p>
                </div>
                <p class="lead text-center" v-if="false">Portal do Paciente</p>
                </div>
                <div class="card-body">
                <div v-if="!novaConta">
                    <p class="lead text-center" v-if="1 == 0">{{ nome }}</p>

                    <div v-if="nome != '...'">
                    <div class="form-group">
                        <input
                        type="text"
                        class="form form-control"
                        placeholder="Login..."
                        name="login-username"
                        v-model="user.login"
                        />
                    </div>

                    <div class="form-group mb-0">
                        <input
                        type="password"
                        class="form form-control"
                        placeholder="Senha..."
                        name="login-userpassword"
                        v-model="user.senha"
                        />
                    </div>
                    </div>
                </div>

                <div v-else>
                    <p class="lead text-center">Nova Conta</p>

                    <div>
                    <div class="row">
                        <div class="col col-12">
                        <az-input
                            label="e-mail"
                            type="email"
                            :edicao="novo.token ? false : true"
                            :validate="validate"
                            v-model="novo.email"
                        />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-12 col-md-6">
                        <az-input
                            label="Nome Completo"
                            type="text"
                            v-if="novo.token"
                            required
                            :validate="validate"
                            v-model="novo.nome"
                        />
                        </div>
                        <div class="col col-12 col-md-6">
                        <az-input
                            label="Sexo"
                            type="sexo"
                            v-if="novo.token"
                            required
                            :validate="validate"
                            v-model="novo.sexo"
                        />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-12 col-md-6">
                        <div class="text-muted" v-if="novo.token">
                            Data de Nascimento
                        </div>
                        <az-data-de-nascimento class="mb-1" v-if="novo.token" v-model="novo.dt_nascimento" />
                        <date-picker
                            type="date"
                            value-type="date"
                            lang="pt-BR"
                            class="mb-3 w-100"
                            format="DD/MM/YYYY"
                            :input-attr="{ required: true }"
                            v-if="1 == 0 && novo.token"
                            v-model="novo.dt_nascimento"
                        ></date-picker>
                        </div>
                        <div class="col col-12 col-md-6">
                        <az-input
                            label="CPF"
                            type="cpf"
                            v-if="novo.token"
                            :validate="validate"
                            v-model="novo.st_cpf"
                        />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-12 col-md-6">
                        <az-input
                            label="Senha"
                            type="password"
                            v-if="novo.token && !novo.authToken"
                            :validate="validate"
                            required
                            v-model="novo.senha"
                        />
                        </div>
                        <div class="col col-12 col-md-6">
                        <az-input
                            label="Confirmar"
                            type="password"
                            v-if="novo.token && !novo.authToken"
                            :validate="validate"
                            required
                            v-model="novo.confirmar"
                        />
                        </div>
                    </div>
                    </div>
                </div>
                </div>

                <div class="card-footer d-flex flex-column" v-if="!novaConta">
                <button
                    class="btn btn-primary"
                    type="submit"
                    :disabled="
                    enviando || nome == '...' || !user.login || !user.senha
                    "
                >
                    <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    v-if="enviando"
                    ></span>
                    <span v-else>Entrar</span>
                </button>

                <button class="btn btn-outline-secondary mt-2" type="button" @click="loginSocial('google')" v-if="false">
                    <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    v-if="enviando"
                    ></span>
                    <span v-else><i class="fab fa-google text-warning"></i> Google</span>
                </button>

                <button class="btn btn-outline-secondary mt-2" type="button" @click="agendarDireto()" v-if="asl">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="enviando"></span>
                    Agendar sem Login
                </button>

                <button
                    v-if="false"
                    class="btn btn-outline-secondary mt-2"
                    type="button"
                    @click="loginSocial('facebook')"
                >
                    <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    v-if="enviando"
                    ></span>
                    <span v-else><i class="fab fa-facebook text-primary"></i> Facebook</span>
                </button>

                <button type="button" data-toggle="modal" data-target="#esqueciModal" @click="validate = false" class="btn btn-link mt-2 mb-2">
                    Esqueci minha senha
                </button>

                <button class="btn btn-outline-success" type="button" @click="novaConta = true">
                    <span>Criar Nova Conta</span>
                </button>

                <button class="btn btn-success mt-2" type="button" @click="agendarDireto()" v-if="false">
                    <span>Agendar</span>
                </button>


                <button type="button" class="btn btn-link mt-2 mb-2" v-if="termo && aceito" @click="removerAceite()">
                    Remover Aceite de Termos
                </button>
                </div>

                <div class="card-footer d-flex flex-column" v-else>
                <button class="btn btn-success mb-2" type="submit" :disabled="enviando">
                    <span
                    class="spinner-border spinner-border-sm mr-2"
                    role="status"
                    aria-hidden="true"
                    v-if="enviando"
                    ></span>
                    <span>{{ novo.token ? "Criar" : "Enviar" }}</span>
                </button>

                <button class="btn btn-outline-secondary" type="button" @click.prevent="voltar()">
                    <span>{{ novo.token ? "Já possuo conta" : "Voltar" }}</span>
                </button>
                </div>
            </div>
        </form>
    </div>

    <div class="row" style="min-height: 100%; min-height: 100vh;" v-if="pronto && !fundo">
      <div class="col">
        <form @submit.prevent="logging" class="d-flex justify-content-center align-items-center h-100">
          <template v-if="user.token || user.id_marcacao">
            <az-loading msg="Aguarde..." />
          </template>

          <div class="card az-anime-surgir" style="padding: 0px;" :style="novaConta ? '' : 'max-width: 400px;'" v-else>
            <div class="card-header" :class="logo ? 'bg-white' : ''">
              <div class="d-flex justify-content-center">
                <img
                  :src="logo"
                  alt="logo"
                  class="logo-responsive"
                  v-if="logo && logo != '?'"
                />
                <p class="lead text-center" v-else>{{ nome }}</p>
              </div>
              <p class="lead text-center" v-if="false">Portal do Paciente</p>
            </div>
            <div class="card-body">
              <div v-if="!novaConta">
                <p class="lead text-center" v-if="1 == 0">{{ nome }}</p>

                <div v-if="nome != '...'">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form form-control"
                      placeholder="Login..."
                      name="login-username"
                      v-model="user.login"
                    />
                  </div>

                  <div class="form-group mb-0">
                    <input
                      type="password"
                      class="form form-control"
                      placeholder="Senha..."
                      name="login-userpassword"
                      v-model="user.senha"
                    />
                  </div>
                </div>
              </div>

              <div v-else>
                <p class="lead text-center">Nova Conta</p>

                <div>
                  <div class="row">
                    <div class="col col-12">
                      <az-input
                        label="e-mail"
                        type="email"
                        :edicao="novo.token ? false : true"
                        :validate="validate"
                        v-model="novo.email"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col-12 col-md-6">
                      <az-input
                        label="Nome Completo"
                        type="text"
                        v-if="novo.token"
                        required
                        :validate="validate"
                        v-model="novo.nome"
                      />
                    </div>
                    <div class="col col-12 col-md-6">
                      <az-input
                        label="Sexo"
                        type="sexo"
                        v-if="novo.token"
                        required
                        :validate="validate"
                        v-model="novo.sexo"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col-12 col-md-6">
                      <div class="text-muted" v-if="novo.token">
                        Data de Nascimento
                      </div>
                      <az-data-de-nascimento class="mb-1" v-if="novo.token" v-model="novo.dt_nascimento" />
                      <date-picker
                        type="date"
                        value-type="date"
                        lang="pt-BR"
                        class="mb-3 w-100"
                        format="DD/MM/YYYY"
                        :input-attr="{ required: true }"
                        v-if="1 == 0 && novo.token"
                        v-model="novo.dt_nascimento"
                      ></date-picker>
                    </div>
                    <div class="col col-12 col-md-6">
                      <az-input
                        label="CPF"
                        type="cpf"
                        v-if="novo.token"
                        :validate="validate"
                        v-model="novo.st_cpf"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col-12 col-md-6">
                      <az-input
                        label="Senha"
                        type="password"
                        v-if="novo.token && !novo.authToken"
                        :validate="validate"
                        required
                        v-model="novo.senha"
                      />
                    </div>
                    <div class="col col-12 col-md-6">
                      <az-input
                        label="Confirmar"
                        type="password"
                        v-if="novo.token && !novo.authToken"
                        :validate="validate"
                        required
                        v-model="novo.confirmar"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer d-flex flex-column" v-if="!novaConta">
              <button
                class="btn btn-primary"
                type="submit"
                :disabled="
                  enviando || nome == '...' || !user.login || !user.senha
                "
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  v-if="enviando"
                ></span>
                <span v-else>Entrar</span>
              </button>

              <button class="btn btn-outline-secondary mt-2" type="button" @click="loginSocial('google')" v-if="false">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  v-if="enviando"
                ></span>
                <span v-else><i class="fab fa-google text-warning"></i> Google</span>
              </button>

              <button class="btn btn-outline-secondary mt-2" type="button" @click="agendarDireto()" v-if="asl">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="enviando"></span>
                Agendar sem Login
              </button>

              <button
                v-if="false"
                class="btn btn-outline-secondary mt-2"
                type="button"
                @click="loginSocial('facebook')"
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  v-if="enviando"
                ></span>
                <span v-else><i class="fab fa-facebook text-primary"></i> Facebook</span>
              </button>

              <button type="button" data-toggle="modal" data-target="#esqueciModal" @click="validate = false" class="btn btn-link mt-2 mb-2">
                Esqueci minha senha
              </button>

              <button class="btn btn-outline-success" type="button" @click="novaConta = true">
                <span>Criar Nova Conta</span>
              </button>

              <button class="btn btn-success mt-2" type="button" @click="agendarDireto()" v-if="false">
                <span>Agendar</span>
              </button>


              <button type="button" class="btn btn-link mt-2 mb-2" v-if="termo && aceito" @click="removerAceite()">
                Remover Aceite de Termos
              </button>
            </div>

            <div class="card-footer d-flex flex-column" v-else>
              <button class="btn btn-success mb-2" type="submit" :disabled="enviando">
                <span
                  class="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                  v-if="enviando"
                ></span>
                <span>{{ novo.token ? "Criar" : "Enviar" }}</span>
              </button>

              <button class="btn btn-outline-secondary" type="button" @click.prevent="voltar()">
                <span>{{ novo.token ? "Já possuo conta" : "Voltar" }}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <Toast />

    <!-- Modal -->
    <div class="modal fade" id="esqueciModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Esqueci minha senha
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <az-input
              class="mb-3"
              type="button-group"
              :optionsList="[
                { id: 'M', search: 'Email' },
                { id: 'C', search: 'CPF' },
              ]"
              v-model="tipo_esqueci" />

            <template v-if="tipo_esqueci == 'M'">
              <az-input
                type="email"
                label="Informe seu e-mail cadastrado"
                required
                :validate="validate"
                v-model="email" />
            </template>

            <template v-if="tipo_esqueci == 'C'">
              <div class="row">
                <div class="col col-12">
                  <az-input
                    type="cpf"
                    label="Informe seu CPF..."
                    required
                    :validate="validate"
                    v-model="esqueci.cpf" />
                </div>
              </div>

              <div class="row">
                <div class="col col-12">
                  <az-input
                    type="number"
                    label="Informe o ano de nascimento..."
                    required
                    :validate="validate"
                    v-model="esqueci.ano" />
                </div>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Fechar
            </button>
            <button type="button" class="btn btn-success" @click="enviar()" :disabled="enviando">
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import $ from "jquery";
import AzInput from "../shared/forms/AzInput.vue";
import DatePicker from "vue2-datepicker";
import AzDataDeNascimento from '../shared/forms/AzDataDeNascimento.vue';
import AzLoading from '../util/AzLoading.vue';
import CookieLaw from 'vue-cookie-law'
  
export default {
  name: "Login",
  data() {
    return {
      nome: "...",
      msg: "",
      enviando: false,
      logo: null,
      user: {
        login: "",
        senha: "",
        token: null,
        id_marcacao: null, 
      },
      email: "",
      validate: false,
      novaConta: false,
      novo: { email: "", nome: "", senha: "", confirmar: "", token: "", authToken: "" },
      aceito: false, 
      termo: null, 
      asl: false,
      ajuda: null,
      tipo_esqueci: 'M', 
      esqueci: { 
        cpf: "",
        ano: ""
      },
      fundo: "", 
      pronto: false, 
    };
  },
  components: {
    AzInput,
    DatePicker,
    AzDataDeNascimento,
    AzLoading,
    CookieLaw
  },
  created() {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);

    if ( this.$route.query.u ) {
        this.user.u = this.$route.query.u;
    }

    if ( this.$route.query.rt ) { 
        this.user.rt = this.$route.query.rt;
    }

    if ( this.$route.query.proc ) { 
        this.user.proc = this.$route.query.proc;
    }

    if ( this.$route.query.esp ) { 
        this.user.esp = this.$route.query.esp;
    }

    if (params.get("mail")) {
        this.novaConta = true;
        this.novo.email = params.get("mail");
        this.novo.token = params.get("token");
        this.novo.nome = params.get("nome") ? params.get("nome") : '';
        this.novo.authToken = params.get("authToken");

        if(params.get("authToken")) {
            const pass = (Math.random() + 1).toString(36).substring(6);
            this.novo.senha = pass;
            this.novo.confirmar = pass;
        }
    } else if (params.get("authToken")) {

        this.user.token = params.get("authToken");
        this.aceito = true;
        this.logging();
        this.resetNovo();
        
    } else if (this.$route.query.id && this.$route.query.t ) {
        this.user.id_marcacao = this.$route.query.id;
        this.user.st_token = this.$route.query.t;
        this.user.login = "";
        this.user.senha = "";
        
        this.aceito = true;

        this.logging();
    }

  },

  mounted() {
    if (process.env.VUE_APP_GTAG) {
      this.$gtag.set({ dimension2: "paciente" });
    }

    let add_query = '';

    if ( this.user.u ) { 
        add_query = '&u=' + this.user.u;
    }

    this.axios.get("/subdomain?p=1" + add_query)
        .then(res => {
            this.nome = res.data.name;
            this.logo = res.data.logo;
            this.termo = res.data.termo;
            this.ajuda = res.data.ajuda;
            this.asl = res.data.asl;
            this.fundo = res.data.fundo; 

            let configs = { 
                nao_marcar_por_outro: res.data.nao_marc_outro
            };

            this.$store.commit('setLogo', this.logo);
            
            this.$emit('ajuda', this.ajuda);
            this.$emit('configs', configs);

            if ( !this.termo )
                this.aceito = true;

            if ( this.$route.query.p && !isNaN(this.$route.query.p) ) { 
                this.$emit('particular', this.$route.query.p);
            }

            if ( this.$route.query.ad ) { 
                this.$nextTick(() => { 
                this.agendarDireto();
                });
            }

            this.$router.replace({ name: "dashboard" });
        })
        .finally(() => { 
            this.pronto = true
        });

    //this.$router.replace({'query': null});

    // console.log(this.$route.query.authToken);

    // Social login
    // if(this.$route.query && this.$route.query.authToken) {
    //     this.user.token = this.$route.query.authToken;
    //     if(!this.$route.query.mail) {
    //       this.logging();
    //       this.$router.replace({'query': null});
    //     }
    // }

  },
  methods: {
    agendarDireto() { 
      if ( !this.verificar_aceito() ) { 
        return;
      }

      this.user.agendar_direto = true;

      this.logging();
    },

    removerAceite() { 
      this.aceito = false;
      this.$refs.cl.revoke();
    },

    criarNovaConta() { 
      if ( !this.verificar_aceito() ) { 
        return 
      }

      this.novaConta = true;
    },

    aceitarTermos() { 
      this.aceito = true;
    },

    voltar() {
      if(this.novaConta == true && !this.novo.authToken) {
        this.novaConta = false
      } else window.location = "/";    
    },
    loginSocial(provider) {
      if ( !this.verificar_aceito() ) { 
        return;
      }

      this.enviando = true;

      this.axios  
        .get(`/social/redirect/${provider}/${this.$store.state.dominio}`)
        .then(res => {
          console.log(res);

          if(res.data && res.data.url) {
              window.location = res.data.url;
          }

        });

    },
    resetNovo() {
      this.novaConta = false;
      this.novo.email = '';
      this.novo.token = '';
      this.novo.nome =  '';
      this.novo.authToken = null;

    },
    cliente() {
      return window.redir;
    },
    enviar() {
      if ( !this.verificar_aceito() ) { 
        return;
      }

      this.validate = true;

      this.$nextTick(() => {
        let invalids = $(".invalid");

        if (invalids.length) {
          //
        } else {
          this.enviando = true;

          this.axios.post("/recuperar_portal", { 
              email: this.email,
              tipo: this.tipo_esqueci, 
              ...this.esqueci
            })
            .then(res => {
              $(".modal").modal("hide");

              this.$toast.add({
                severity: res.data.level,
                summary: "Atenção",
                detail: res.data.msg,
                life: 10000
              });
            })
            .finally(() => { 
              this.enviando = false;
            });
        }
      });
    },
    solicitar_cadastro() {
      this.axios
        .post("solicitar_cadastro", { ...this.novo })
        .then(res => {
          console.log(res);

          this.$toast.add({
            severity: "success",
            summary: "Cadastro",
            detail: "Solicitação enviada. Verifique seu e-mail.",
            life: 3000
          });

          setTimeout(() => {
            window.location = "/";
          }, 3000);
        })
        .finally(() => {
          this.$store.commit("loading", false);
          this.enviando = false;
        });
    },

    verificar_aceito() { 
      if ( !this.aceito ) { 
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: "Necessários aceitar os termos de uso.",
          life: 3000
        });
        
        return false;
      }

      return true;
    },

    async logging() {
      if ( !this.verificar_aceito() ) { 
        return;
      }
      
      this.enviando = true;
      this.$store.commit("loading", true);

      if (this.novaConta) {
        if (!this.novo.token) {
          this.solicitar_cadastro();
        } else {
          console.log("login");
          let dadosNovo = { ...this.novo };

          if ( !this.novo.dt_nascimento ) { 
            this.$toast.add({
              severity: "error",
              summary: "Atenção",
              detail: "Informar data de nascimento.",
              life: 3000
            });
            this.enviando = false;
            this.$store.commit("loading", false);
            return;
          }

          dadosNovo.dt_nascimento = new Date(this.novo.dt_nascimento)
            .toISOString()
            .split("T")[0];

          this.axios
            .post("register", dadosNovo)
            .then(res => {
              this.enviando = false;

              if (this.novo.token) {
                this.enviando = false;
                this.$store.commit("setUser", null);

                if (res.data == "Conta Criada") {
                  this.$toast.add({
                    severity: "success",
                    summary: "Conta",
                    detail: "Conta Criada. Acesse com seu e-mail e senha.",
                    life: 3000
                  });

                  setTimeout(() => {
                    if(this.novo.authToken) {
                      this.user.login = this.novo.email;
                      this.user.token = this.novo.authToken;

                      this.novaConta = false;
                      this.logging();
                    } else {    
                      this.user.login = this.novo.email;
                      this.user.senha = this.novo.senha;

                      this.novaConta = false;
                      this.logging();
                      // window.location = "/";
                    }
                  }, 3000);
                }

                /*
                const userData = res.data.user;
                if (userData) {
                  this.$store.commit("setUser", userData);
                  this.axios.defaults.headers.post["Authorization"] =
                    "bearer " + res.data.access_token;
                  this.axios.defaults.headers.get["Authorization"] =
                    "bearer " + res.data.access_token;
                }
                */
              } else {
                this.$toast.add({
                  severity: res.data.level,
                  summary: "Atenção",
                  detail: res.data.msg,
                  life: 3000
                });
              }
            })
            .catch(() => {
              this.$store.commit("loading", false);
              this.enviando = false;
            })
            .finally(() => {
              this.$store.commit("loading", false);
            });
        }
      } else {
        this.axios
          .post("login", this.user)
          .then(res => {
            if ( res.data.url ) { 
              window.location = res.data.url;
              return;
            }

            res.data.unidade.resultados = res.data.portal_resultados;
            res.data.unidade.agendas = !res.data.portal_block_agd;

            this.enviando = false;
            const userData = { 
              ...res.data.user, 
              info: { 
                proc: this.user.proc,
                esp: this.user.esp, 
              }
            };
            const unidadeData = res.data.unidade;

            this.$store.commit("setUser", null);

            // Unidade
            this.$store.commit("setUnidade", null);
            if (unidadeData) {
              this.$store.commit("setUnidade", unidadeData);
            }

            if (userData) {
              this.$store.commit("setUser", userData);
              this.axios.defaults.headers.post["Authorization"] =
                "bearer " + res.data.access_token;
              this.axios.defaults.headers.get["Authorization"] =
                "bearer " + res.data.access_token;

              if ( this.user.rt ) { 
                setTimeout(() => {
                  this.$router.push({ path: this.user.rt });
                }, 200);
              } else if ( this.$store.state.user.st_tipo == 'O' ) { 
                setTimeout(() => {
                    this.$router.push({ name: "apoioresultados" });    
                }, 200);
              } else if ( this.$router.currentRoute.path == '/' && !this.$store.state.unidade.agendas ) { 
                setTimeout(() => {
                    this.$router.push({ name: "resultados" });
                }, 200);
              }
            }
          })
          .catch(() => {
            this.$store.commit("loading", false);
            this.enviando = false;
          })
          .finally(() => {
            this.$store.commit("loading", false);
          });
      }
    }
  }
};

//components: { AppSpinner },
</script>

<style scoped>
.logo-responsive {
  max-width: 100%;
  height: auto;
}

.az-anime-surgir {
  animation: az-surgir 1s;
}

@keyframes az-surgir {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1) ease-in-out;
  }
}

@media only screen and (min-width: 900px) {

  .naesquerda { 
    width: 400px; 
    height: 100vh;
    padding: 10px;
    background-color: white;
  }

  .imagem-fundo {
    background-repeat: no-repeat;
    background-color: black;
    background-size: cover;
    background-position: left 400px top;
  }

  .card { 
    border: none !important;
  }

}

@media only screen and (max-width: 900px) {

  .loginmobile { 
    height: 100vh;
    padding: 10px;
  }

  .imagem-fundo {
    background-repeat: no-repeat;
    background-color: black;
    background-size: cover;
    background-position: center center;
  }

}

</style>
